import { createContext, useState } from 'react';

export interface FormState {
  submitting: boolean;
  valid: boolean;
  error: string;
  setSubmitting(submitting: boolean): void;
  setValid(valid: boolean): void;
  setError(error: string): void;
}

export const FormContext = createContext<FormState>({
  submitting: false,
  valid: true,
  error: '',
  setSubmitting: () => {},
  setValid: () => {},
  setError: () => {},
});

interface Props {
  children?: React.ReactNode;
}

export function FormProvider(props: Props) {
  const [submitting, setSubmitting] = useState(false);
  const [valid, setValid] = useState(false);
  const [error, setError] = useState('');

  const value = {
    submitting,
    valid,
    error,
    setSubmitting,
    setValid,
    setError,
  };

  return (
    <FormContext.Provider value={value}>{props.children}</FormContext.Provider>
  );
}
